import { useBrowserPushLifecycle } from "./useBrowserPushLifecycle";

export default function BrowserPushLifecycle() {
  useBrowserPushLifecycle();
  return null;
}
